import React from 'react';
import { Outlet, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Skupna lupina PWA: glava (logo/nazaj + odjava) + vsebina.
// Navigacija poteka prek gumbov na glavnem zaslonu (kot Android), zato ni spodnjih zavihkov.
// Prijava je skupna z glavno app (isti token) — tu je edini varovalni preusmerek.
export default function EndUserLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();

  if (loading) return <div style={{ padding: 24, textAlign: 'center', color: '#666' }}>Nalagam…</div>;
  if (!user) return <Navigate to="/app/prijava" replace />;

  const isMain = loc.pathname === '/app' || loc.pathname === '/app/';
  const title = loc.pathname.startsWith('/app/sms')
    ? 'SMS plošča'
    : loc.pathname.startsWith('/app/filter')
      ? 'Moj filter'
      : loc.pathname.startsWith('/app/v-okvari')
        ? 'V okvari'
        : loc.pathname.startsWith('/app/prvi-lastnik')
          ? '1. lastnik'
          : '';

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5', display: 'flex', flexDirection: 'column' }}>
      <header
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 40,
          background: '#fff',
          color: '#111',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 10,
          padding: '12px 16px',
          paddingTop: 'calc(12px + env(safe-area-inset-top))',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        }}
      >
        {isMain ? (
          <span style={{ fontWeight: 700, fontSize: 22, color: '#111' }}>AvtoRadar</span>
        ) : (
          <button
            onClick={() => navigate('/app')}
            style={{ background: 'transparent', border: 'none', color: '#007AFF', fontSize: 16, fontWeight: 600, cursor: 'pointer', padding: 0 }}
          >
            ‹ Nazaj
          </button>
        )}
        {!isMain ? <span style={{ fontWeight: 700, fontSize: 17, color: '#111' }}>{title}</span> : null}
        <button
          onClick={() => { logout(); navigate('/app/prijava'); }}
          style={{ background: '#FF3B30', border: 'none', color: '#fff', padding: '7px 14px', borderRadius: 16, fontSize: 13, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }}
        >
          Odjava
        </button>
      </header>

      <main style={{ flex: 1, width: '100%', maxWidth: 600, margin: '0 auto', padding: '14px 12px 28px', boxSizing: 'border-box' }}>
        <Outlet />
      </main>
    </div>
  );
}
